// TODO: may need to give modal the ability to have a sub-view / views
// ... current uses have it overridable or have content that doesn't require interaction
// this is extending the existing modal dialog directly

// TODO: when modal is open, disable document keyboard events -- currently used in mousetrap

var Modal = require('../../common/modal/modal'),
    _ = require('underscore'),
    Util = require('../../FV/util');

require('./style.less');

module.exports = Modal.extend({
    baseModalDefaults: {
        title: 'Reorder Pages'
    },
    contentTemplate: require('./template.hbs'),
    initialize: function(options) {

        this.numberPagesInDocument = options.numberPagesInDocument;

        this.settings = _.extend( {}, {
            content: this.contentTemplate( this.serializeContentTemplateData() )
        }, options );

        Modal.prototype.initialize.call( this, _.extend( {}, this.settings, this.baseModalDefaults) );

        return this;
    },

    onShow: function() {
        Modal.prototype.onShow.apply(this, arguments);
        setTimeout( _.bind( function() {
            this.ui.movePgInput.select();
        }, this), 1 );
    },
    serializeContentTemplateData: function() {
        return {
            currentPgNumber: this.options.currentPgNumber,
            movePgsInputName: Util.getUniqueStrToDisableFormAutoComplete(),
            moveToInputName: Util.getUniqueStrToDisableFormAutoComplete()
        };
    },

    ui: _.extend( {}, Modal.prototype.ui, {
        movePgInput:    '#rp-move-input',
        moveToPgInput:  '#rp-move-to-pg',
        afterCheckbox:  '#rp-after-cb',
        radioBtns:      '.rp-pos-radio',
        moveToLbl:      '#rp-move-to-lbl',

        // may want to make validation and these common ... at least use same classes, etc ...
        errorMessageWr:         '.dialog-err-msg-wr',
        errorMessageTxt:        '.dialog-err-msg-txt'
    }),

    events: _.extend( {} , Modal.prototype.events, {
        'change @ui.radioBtns':  'onRadioBtnChange'
    }),

    ok: function() {

        // TODO: util for err msg
        this.ui.errorMessageWr.addClass('hide');
        this.ui.errorMessageTxt.text('');


        // 1) Fail if first input is not valid
        var pgsToMove = this.getPgsToMove( this.ui.movePgInput.val() );
        if ( typeof pgsToMove === 'string' ) {
            this._showValidationErrorMsg(pgsToMove);
            return;
        }

        // 2) Fail if second not valid
        var destinationPg = this.getDestinationPg( this.ui.moveToPgInput.val() );
        if (typeof destinationPg === 'string') {
            this._showValidationErrorMsg(destinationPg);
            return;
        }

        // 3) Fail if combo of each is not valid

        // 3a) Fail if the destination page is in the list of pages to be moved
        if ( _.contains(pgsToMove, destinationPg) ) {
            this._showValidationErrorMsg('Destination page is in the list of pages to be moved.');
            return;
        }

        //3b) Fail if operation would not result in change of pages -- could be a fn itself ... all these necessary?
        var insertAfter = this.isAfterChecked();

        var begPg = pgsToMove[0],
            endPg = pgsToMove.length > 1 ? _.last(pgsToMove) : pgsToMove[0];

        //  (need =)???
        if ( begPg <= destinationPg && destinationPg <= endPg ) {
            this._showValidationErrorMsg('Operation would cause no change in page order.');
            return;
        }

        // eg: don't insert 4 before 5; 2-4 before 5
        if ( !insertAfter && endPg + 1 === destinationPg ) {
            this._showValidationErrorMsg('Operation would cause no change in page order.');
            return;
        }

        // eg: don't insert 5 after 4; insert 4-5 after 3
        if ( insertAfter && begPg - 1 === destinationPg ) {
            this._showValidationErrorMsg('Operation would cause no change in page order.');
            return;
        }

        this.destroy();
        this.settings.okCB( pgsToMove, destinationPg, insertAfter );


    },

    // return err msg if invalid or array of pages numbers to move
    getPgsToMove: function( input ) {

        var errPrefix = 'Pages to be moved is invalid: ';

        if (!input)
            return errPrefix + 'none specified.';

        // remove any spaces -- expression below allows for spaces in the middle of reg ex but not at beg or end
        input = input.replace(/\s/g, '');

        var re = /^\d+(?:-\d+)?$/gm;
        if (!re.test(input))
            return errPrefix + 'provide a single integer or two integers separated by a dash (-).';


        if ( input.indexOf('-') < 1 ) {

            // Single Page
            var pgNum = parseInt(input); //handle leading zeros

            return this.pgNumExistsInDocument(pgNum)
                ? [pgNum]
                : errPrefix + 'page ' + pgNum + ' does not exist in the document.';

        } else {

            // Range
            var pgs = input.split('-'),
                pg1 = parseInt( pgs[0] ),
                pg2 = parseInt( pgs[1] ),
                pg1IsValid = this.pgNumExistsInDocument(pg1),
                pg2IsValid = this.pgNumExistsInDocument(pg2);

            if ( pg1IsValid && pg2IsValid ) {

                // both pages are valid -- return sorted array of the page range

                var pgMin = Math.min( pg1, pg2 ),
                    pgMax = Math.max( pg1, pg2 ),
                    aPgs = _.range( pgMin,  pgMax );
                    aPgs.push(pgMax);
                    aPgs = _.sortBy(aPgs, function(n) { return n; });

                return aPgs;


            } else {

                var invalidPgs = [];
                !pg1IsValid && invalidPgs.push( pg1 );
                !pg2IsValid && invalidPgs.push( pg2 );

                return errPrefix + 'page' + (invalidPgs.length > 1 ? 's ' : ' ') +
                     invalidPgs.join(', ') + (invalidPgs.length > 1 ? ' do' : ' does') +
                    ' not exist in the document.';

            }
        }

    },

    // return err msg if invalid of the destination page number
    getDestinationPg: function( input ) {

        var errPrefix = 'Invalid destination page: ';

        if (!input)
            return errPrefix + 'none specified.';

        input = input.replace(/\s/g, '');

        if (!/^\d+$/gm.test(input))
            return errPrefix + 'provide a single page number.';

        var pgNum = parseInt(input); //handle leading zeros
        return this.pgNumExistsInDocument(pgNum)
            ? pgNum
            : errPrefix + 'page ' + pgNum + ' does not exist in the document.';

    },

    pgNumExistsInDocument: function(n) {
        return n > 0 && n <= this.numberPagesInDocument;
    },

    onRadioBtnChange: function() {
        var txt = this.ui.moveToLbl.text();
        this.ui.moveToLbl.text( txt.replace( /before|after/gi , this.isAfterChecked() ? 'After' : 'Before') );
    },

    isAfterChecked: function() {
        return this.ui.afterCheckbox.is(':checked');
    },

    // TODO: common w delete pg ... should make part of modal ...
    _showValidationErrorMsg: function(msg) {
        this.ui.errorMessageWr.removeClass('hide'); // could make top level in css
        this.ui.errorMessageTxt.html(msg);
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/dialogs/reorderPages/view.js
 ** module id = 142
 ** module chunks = 0
 **/